export const APP_DATA = {
  API_URL: "http://213.173.108.18:13877/api/",
};

export const API_ENDPOINT = {
  REGISTER: "/user/register/",
  LOGIN: "http://54.195.95.147:8810/api/user/auth/login/email",
  VALIDATE_OTP: "http://54.195.95.147:8810/api/user/auth/validate-otp",
  CREATENEWCHATAI: "/chat/rooms/create_ai_chat/",
  AIRESPONSE: "http://213.173.108.11:18355/stream?prompt=",
  AITESTRESPONSE: "http://213.173.108.11:18355/stream?prompt=",
  AIDOCUMENT: "http://213.173.108.11:18355/stream?prompt=",
  AIREASONING: "http://213.173.108.11:18355/stream?prompt=",
  AICODING: "http://213.173.108.6:15140/stream?prompt=",
};
